import { render, staticRenderFns } from "./RealEstateDevelopmentList.vue?vue&type=template&id=320bf2d6&scoped=true"
import script from "./RealEstateDevelopmentList.vue?vue&type=script&lang=js"
export * from "./RealEstateDevelopmentList.vue?vue&type=script&lang=js"
import style0 from "./RealEstateDevelopmentList.vue?vue&type=style&index=0&id=320bf2d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320bf2d6",
  null
  
)

export default component.exports